<template>
  <div>
    <div class="unit-card-wrapper">
      <a-row>
        <a-col
          :span="4"
          v-for="(unit, index) in courseUnitResult.records"
          :key="index"
        >
          <a-card>
            <div slot="cover" @click="viewUnit(unit)">
              <img :src="unit.unitCover_url" alt="">
            </div>
            <template slot="actions">
              <p>{{unit.unitName}}</p>
            </template>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { getStudentCourseUnit, getMineCourse } from "@/api/course";

export default {
  name: "MineUnitMap",
  components: {},
  data() {
    return {
      courseId: "",
      departId: "",
      courseInfo: {},
      courseUnitResult: {},
      currentUnit: {},
      finishedWork: [],
      unFinishedWork: [],
    };
  },
  created() {
    this.courseId = this.$route.query.courseId;
    this.departId = this.$route.query.departId;
    this.getCourseUnit();
    this.getCourseInfo();
  },
  methods: {
    getCourseInfo() {
      getMineCourse({courseId: this.courseId}).then((res) => {
        this.courseInfo = res.result.records[0];
      });
    },
    getCourseUnit() {
      getStudentCourseUnit(this.departId, this.courseId, 1, 99).then((res) => {
        if (res.success) {
          this.courseUnitResult = res.result;
          this.unFinishedWork = res.result.records.filter((x) => {
            return x.mineWorkId == null;
          });
          this.finishedWork = res.result.records.filter((x) => {
            return x.mineWorkId != null;
          });
        }
      });
    },
    viewUnit(unit) {
      this.showEnterModal = true;
      this.currentUnit = unit;
    },
    toUnit() {
      let unit = this.currentUnit;
      if (unit.openTime == null || unit.serverTime < unit.openTime) {
        return;
      }
      this.$router.push({
        path: `/center/classroom?unitId=${unit.id}&courseId=${this.courseId}&departId=${this.departId}`,
      });
    },
    isPoint(index, unit) {
      if (unit.isOpen) {
        let list = this.courseUnitResult.records;
        let maxIndex = 0;
        for (var i = 0; i < list.length; i++) {
          if (list[i].isOpen) {
            maxIndex = i;
          }
        }
        if (maxIndex == index) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="less">
</style>